module.exports = __webpack_public_path__ + "static/media/V1_ROUGH.504a004e.png";